import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ISidebarMenuSubProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useSidebarRootContext,
    useSidebarItemContext,
    SidebarSubContext
} from "../../context";
import {
    getSidebarMeasures
} from "../../stylesheet";
import CollapseRegion from "../../../collapsible/internal/collapseRegion";

const SidebarMenuSub: FC<ISidebarMenuSubProps> = ({
    customTheme: customThemeProp,
    children,
    style,
    ...props
}) => {
    const root = useSidebarRootContext({
        part: "Sidebar.MenuSub"
    });

    const item = useSidebarItemContext();

    const customTheme = customThemeProp ?? root?.customTheme;

    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const measures = getSidebarMeasures({
        controlPaddings,
        controlHeights,
        shapeConfigs,
        spaces
    });

    const {
        container: containerDynamicStyle,
        guide: guideDynamicStyle
    } = useStyles({
        measures,
        borders,
        colors,
        spaces
    });

    if(root?.isCollapsed) {
        return null;
    }

    return <CollapseRegion
        {...props}
        isOpen={!item || !item.isCollapsible || item.isExpanded}
        contentStyle={[
            stylesheet.container,
            containerDynamicStyle
        ]}
        customTheme={customTheme}
        id={item?.subId}
        style={style}
        role="list"
    >
        <View
            style={[
                stylesheet.guide,
                guideDynamicStyle
            ]}
            aria-hidden={true}
        />
        <SidebarSubContext.Provider
            value={true}
        >
            {children}
        </SidebarSubContext.Provider>
    </CollapseRegion>;
};
export default SidebarMenuSub;
